/* ==========================================================================
   rg-recently-viewed.js — 閲覧履歴(最近見た商品)

   仕組み:
   1. 商品ページを開くと、その商品のパスを localStorage に保存する
   2. 保存済みのパスを新しい順に読み、/products/<handle>?view=card で
      カードのHTMLだけを取得して並べる(templates/product.card.liquid)

   設計上の注意:
   - 履歴は端末内(localStorage)のみに保存し、外部へは一切送信しない。
   - ハンドルではなくパスを保存している。日本語ハンドルの商品があるため、
     ブラウザがエンコード済みの location.pathname をそのまま使う方が安全。
   - /collections/<x>/products/<y> のようなコレクション経由のURLでも
     同じ商品として扱えるよう /products/<handle> 部分だけを取り出す。
   ========================================================================== */

(function () {
  'use strict';

  var STORAGE_KEY = 'rg:recently-viewed';
  var STORE_MAX = 30; // 表示件数より多めに保持しておく(売切・削除で欠けても埋まるように)

  /** localStorage が使えない環境(プライベートモード等)でも落ちないようにする */
  function readHistory() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(function (p) { return typeof p === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, STORE_MAX)));
    } catch (e) {
      /* 保存できなくても表示側は動くので握りつぶす */
    }
  }

  /** 現在URLから /products/<handle> の形に正規化する。商品ページ以外では null */
  function currentProductPath() {
    var match = window.location.pathname.match(/\/products\/[^/?#]+/);
    return match ? match[0] : null;
  }

  function remember(path) {
    if (!path) return;
    var list = readHistory().filter(function (p) { return p !== path; });
    list.unshift(path);
    writeHistory(list);
  }

  /** カードHTMLを取得。存在しない商品(削除済み等)は null を返す */
  function fetchCard(path) {
    return fetch(path + '?view=card', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return null;
        return res.text();
      })
      .then(function (html) {
        if (!html) return null;
        var trimmed = html.trim();
        return trimmed ? trimmed : null;
      })
      .catch(function () {
        return null;
      });
  }

  function render(section) {
    var grid = section.querySelector('[data-rg-recently-viewed-grid]');
    if (!grid) return;

    var limit = parseInt(section.getAttribute('data-limit'), 10) || 10;
    var currentPath = currentProductPath();

    // 表示中の商品は履歴に出さない
    var targets = readHistory()
      .filter(function (p) { return p !== currentPath; })
      .slice(0, limit);

    if (!targets.length) return;

    Promise.all(targets.map(fetchCard)).then(function (cards) {
      var alive = [];
      var fragment = document.createDocumentFragment();

      cards.forEach(function (html, index) {
        if (!html) return;
        alive.push(targets[index]);
        var li = document.createElement('li');
        // base.css の .grid__item は幅25%固定で1行レイアウトと競合するため専用クラスを使う
        li.className = 'rg-recently-viewed__item';
        li.innerHTML = html;
        fragment.appendChild(li);
      });

      if (!fragment.childNodes.length) return;

      grid.appendChild(fragment);
      section.hidden = false;

      // 取得に失敗した(削除された)商品を履歴から取り除く
      var removed = targets.filter(function (p) { return alive.indexOf(p) === -1; });
      if (removed.length) {
        writeHistory(readHistory().filter(function (p) { return removed.indexOf(p) === -1; }));
      }
    });
  }

  function init() {
    var section = document.querySelector('[data-rg-recently-viewed]');

    // 描画は「今の商品を履歴に加える前」に行う(自分自身が並ばないように)
    if (section) render(section);

    remember(currentProductPath());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
